const API_ENDPOINTS = {
  CUSTOMER_SERVICE_INFO: "/customervehicle/serviceinfo",
  CUSTOMER_GET_BY_ID: "/customer/get/id",
  CUSTOMER_GET_VEHICLE_BY_ID: "/customer/get/vehicle/vehicleid",
  CUSTOMER_GET_YEAR_MAKES: "/customer/get/year/makes",
  CUSTOMER_UPDATE: "/customer/update",
  CUSTOMER_CREATE: "/customer/create",
  CUSTOMER_CREATE_VEHICLE: "/customer/create/vehicle",
  CUSTOMER_UPDATE_VEHICLE: "/customer/update/vehicle",
  CUSTOMER_GET_VEHICLE_BY_VIN: "/customer/get/vehicle/vin",
  CUSTOMER_GET_VEHICLE_ID: "/customer/get/vehicle/id",
  CUSTOMER_GET_VEHICLE: "/customer/get/vehicle",
  CUSTOMER_GET_YEAR_MOTOR: "/customer/get/model",
  CUSTOMER_GET_SUBMODELS_MOTOR: "customer/get/submodels",
  CUSTOMER_GET_ENGINE_BODY: "customer/get/vehicle/body/engine",
  DEALER_CREATE: "/dealer/create",
  DEALER_CREATE_USER: "/dealer/create/user",
  DEALER_GET_USER: "/dealer/get/user",
  DEALER_TENANT_USER: "/dealer/tenant/user",
  DEALER_GET_ID: "/dealer/get/id",
  DEALER_GET_LIST: "/dealer/get/list",
  DEALER_ASSIGN_USER: "/dealer/assign/user",
  DEALER_GET_SERVICES: "/dealer/get/services",
  DEALER_UPLOAD_IMAGE: "/dealer/upload-image",
  DEALER_UPDATE: "/dealer/update",
  DEALER_DELETE_SERVICES: "/dealer/delete/services",
  DEALER_GET_SERVICE_BY_ID: "/dealer/get/service/by/id",
  DEALER_UPDATE_SERVICES: "/dealer/update/services",
  DEALER_ORDER_STATUS: "/dealer/order/status",
  DEALER_SERVICES: "/dealer/services",
  DEALER_CREATE_SERVICE: "/dealer/create/services",
  DEALER_DELETE: "/dealer/delete",
  DASHBOARD_GET: "/dashboard/get",
  REPAIR_ORDER_BY_CUSTOMER_ID: "/repairorder/customerid",
  REPAIR_ORDER_CREATE: "/repairorder/create",
  REPAIR_ORDER_UPDATE: "/repairorder/update",
  REPAIR_ORDER_STATUS_GET: "/repair/order/status/get",
  REPAIR_ORDER_TOKEN: "/repair/order/token",
  REPAIR_ORDER_GET_ALL: "repairorder/get/all",
  REPAIR_ORDER_ITEM: "repairorder/item/get/By/Id",
  REPAIR_ORDER_ITEMS_BULK: "repairorder/items/get/by/ids",
  SEND_EMAIL: "/send/email",
  SEND_SMS: "/send/sms",
  DROPDOWN_DEALERSHIPS: "/dropdown/dealerships",
  DROPDOWN_CITIES_BY_STATE: "/dropdown/cities/state",
  API_CUSTOMER_GET_YEAR_MOTOR: "/customer/get/year/motor",
  SERVICES_CATEGORY: "/customer/get",
  REFRESH_TOKEN: "/dealer/auth/refresh",
  REPAIR_ORDER_PRINT: "/repair/order/print/history",
  REPAIR_ORDER_GET_BY_ID: "/repairorder/get/by/id",
  EXTERNAL_USER_CREATE: "/dealer/external-user/create",
  EXTERNAL_USER_GET_ALL: "/dealer/external-user/list",
  EXTERNAL_USER_GET_BY_ID: "/dealer/external-user",
  EXTERNAL_USER_UPDATE: "/dealer/external-user/update",
  EXTERNAL_USER_DELETE: "/dealer/external-user/delete",
  EXTERNAL_USER_TOGGLE_STATUS: "/dealer/external-user/activate-deactivate",
  EXTERNAL_USER_LOGIN: "/dealer/external-user/login",
  EXTERNAL_USER_FORGOT_PASSWORD: "/dealer/external-user/forgot-password",
  EXTERNAL_USER_RESET_PASSWORD: "/dealer/external-user/reset-password",
  EXTERNAL_USER_SET_PASSWORD: "/dealer/external-user/set-password",
  EXTERNAL_USER_VALIDATE_TOKEN: "/dealer/external-user/validate-token",
  EXTERNAL_USER_RESEND_INVITATION: "/dealer/external-user/resend-invitation",
};

export default API_ENDPOINTS;
